import React from "react";
import { FormattedMessage } from "react-intl";

export const installmentsModePayment = [
  {
    key: "MP01",
    desc: <FormattedMessage id="parties.payment.MP01" />
  },
  {
    key: "MP02",
    desc: <FormattedMessage id="parties.payment.MP02" />
  },
  {
    key: "MP03",
    desc: <FormattedMessage id="parties.payment.MP03" />
  },
  {
    key: "MP04",
    desc: <FormattedMessage id="parties.payment.MP04" />
  },
  {
    key: "MP05",
    desc: <FormattedMessage id="parties.payment.MP05" />
  },
  {
    key: "MP06",
    desc: <FormattedMessage id="parties.payment.MP06" />
  },
  {
    key: "MP07",
    desc: <FormattedMessage id="parties.payment.MP07" />
  },
  {
    key: "MP08",
    desc: <FormattedMessage id="parties.payment.MP08" />
  },
  {
    key: "MP09",
    desc: <FormattedMessage id="parties.payment.MP09" />
  },
  {
    key: "MP12",
    desc: <FormattedMessage id="parties.payment.MP12" />
  },
  {
    key: "MP13",
    desc: <FormattedMessage id="parties.payment.MP13" />
  },
  {
    key: "MP14",
    desc: <FormattedMessage id="parties.payment.MP14" />
  },
  {
    key: "MP15",
    desc: <FormattedMessage id="parties.payment.MP15" />
  },
  {
    key: "MP16",
    desc: <FormattedMessage id="parties.payment.MP16" />
  },
  {
    key: "MP19",
    desc: <FormattedMessage id="parties.payment.MP19" />
  },
  {
    key: "MP22",
    desc: <FormattedMessage id="parties.payment.MP22" />
  },
  {
    key: "MP23",
    desc: <FormattedMessage id="parties.payment.MP23" />
  },
  {
    key: "MPXC",
    desc: <FormattedMessage id="parties.payment.MPXC" />
  },
  {
    key: "MPXA",
    desc: <FormattedMessage id="parties.payment.MPXA" />
  }
];
